<div [class]="'app-wrapper min-vh-100 ' + globals.contentBackground">
    <router-outlet></router-outlet>
</div>
